import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Calendar, Clock, Users, Bike, Activity, CalendarDays, Zap, HeartHandshake } from 'lucide-react';
import { classesData, scheduleData, specialActivities, seniorCareData, clubData } from '../data/mock';

export const Classes = () => {
  return (
    <section id="classes" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            <span className="text-[#39FF14]">Classes</span> Dirigides
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-6">
            {scheduleData.period} oferim classes dirigides amb aforament limitat
          </p>
          <div className="inline-block bg-[#39FF14]/10 border border-[#39FF14] rounded-full px-6 py-2">
            <p className="text-[#39FF14] font-bold">
              Màxim 15 persones per classe
            </p>
          </div>
        </div>

        {/* Schedule Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-12 max-w-4xl mx-auto">
          {classesData.map((classItem) => {
            const isSpinfit = classItem.id === 'spinfit-dimarts';
            return (
              <Card
                key={classItem.id}
                className={`${
                  isSpinfit
                    ? 'bg-gradient-to-br from-[#39FF14]/20 to-gray-800 border-2 border-[#39FF14] shadow-xl shadow-[#39FF14]/20'
                    : 'bg-gradient-to-br from-gray-900 to-gray-800 border-2 border-gray-700 hover:border-[#39FF14]'
                } transition-all duration-300 hover:shadow-xl hover:shadow-[#39FF14]/20 group relative overflow-hidden`}
              >
                {classItem.isNew && (
                  <div className="absolute top-0 right-0 bg-[#39FF14] text-black px-3 py-1 text-xs font-bold">
                    NOU!
                  </div>
                )}
                <CardHeader>
                  <div className="flex items-center justify-between mb-2">
                    <div className={`${isSpinfit ? 'bg-[#39FF14]' : 'bg-[#39FF14]/20'} p-2 rounded-lg`}>
                      {isSpinfit ? (
                        <Zap className="w-6 h-6 text-black" />
                      ) : (
                        <Activity className="w-6 h-6 text-[#39FF14]" />
                      )}
                    </div>
                    <span className={`${isSpinfit ? 'bg-[#39FF14] text-black' : 'bg-[#39FF14]/10 text-[#39FF14]'} text-sm font-bold px-3 py-1 rounded-full`}>
                      {classItem.day}
                    </span>
                  </div>
                  <CardTitle className={`${isSpinfit ? 'text-[#39FF14]' : 'text-white'} text-2xl`}>
                    {classItem.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Clock className="w-5 h-5 text-[#39FF14]" />
                    <span className="font-bold text-xl">{classItem.time}</span>
                    <span className="text-gray-500">({classItem.duration})</span>
                  </div>
                  
                  <div className="flex items-center gap-2 text-gray-400">
                    <Users className="w-5 h-5 text-[#39FF14]" />
                    <span>Màxim {classItem.maxCapacity} persones</span>
                  </div>

                  <p className="text-gray-400 text-sm mt-3">
                    {classItem.description}
                  </p>

                  {classItem.types && !classItem.rotation && (
                    <div className="mt-4 pt-4 border-t border-gray-700">
                      <p className="text-xs text-gray-500 mb-2">Tipus de classes:</p>
                      <div className="flex flex-wrap gap-2">
                        {classItem.types.map((type, index) => (
                          <span
                            key={index}
                            className="text-xs bg-gray-800 text-[#39FF14] px-2 py-1 rounded-full"
                          >
                            {type}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {classItem.rotation && (
                    <div className="mt-4 pt-4 border-t border-gray-700">
                      <p className="text-xs text-gray-500 mb-3">Rotació mensual:</p>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-[#39FF14] rounded-full"></div>
                          <span className="text-gray-400">{classItem.rotation.bodyPump} Body Pump</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-[#39FF14] rounded-full"></div>
                          <span className="text-gray-400">{classItem.rotation.gac} GAC</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-[#39FF14] rounded-full"></div>
                          <span className="text-gray-400">{classItem.rotation.aerobic} Aeròbic</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-[#39FF14] rounded-full"></div>
                          <span className="text-gray-400">Abril: {classItem.rotation.april}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-[#39FF14] rounded-full"></div>
                          <span className="text-gray-400">Maig: {classItem.rotation.may}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="pt-4">
                    <a
                      href={clubData.reservationForm}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`block w-full text-center ${
                        isSpinfit
                          ? 'bg-[#39FF14] hover:bg-[#2EDD0F] text-black'
                          : 'bg-[#39FF14] hover:bg-[#2EDD0F] text-black'
                      } font-bold py-3 rounded-lg transition-all duration-300 transform hover:scale-105`}
                    >
                      Reserva Plaça
                    </a>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Senior / personalized care */}
        <div className="max-w-4xl mx-auto mb-12">
          <Card
            data-testid="senior-care-card"
            className="bg-gradient-to-br from-[#39FF14]/15 to-gray-900 border-2 border-[#39FF14]/50 hover:border-[#39FF14] transition-all duration-300 overflow-hidden"
          >
            <CardContent className="p-6 md:p-8">
              <div className="flex flex-col md:flex-row md:items-center gap-6">
                <div className="bg-[#39FF14]/20 p-4 rounded-2xl w-fit">
                  <HeartHandshake className="w-10 h-10 text-[#39FF14]" />
                </div>
                <div className="flex-1">
                  <h3 className="text-white text-2xl font-black mb-2">{seniorCareData.title}</h3>
                  <p className="text-gray-300 text-sm md:text-base mb-4">{seniorCareData.description}</p>
                  <div className="flex flex-wrap gap-4">
                    <div className="flex items-center gap-2 text-gray-300">
                      <Calendar className="w-5 h-5 text-[#39FF14]" />
                      <span className="font-bold">{seniorCareData.day}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                      <Clock className="w-5 h-5 text-[#39FF14]" />
                      <span className="font-bold">{seniorCareData.time}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-300">
                      <Users className="w-5 h-5 text-[#39FF14]" />
                      <span>Màxim {seniorCareData.maxCapacity} persones</span>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Note */}
        <div className="mt-8 text-center">
          <p className="text-gray-400">
            <span className="text-[#39FF14] font-bold">Important:</span> {scheduleData.note}
          </p>
        </div>
      </div>
    </section>
  );
};
